import React from 'react'

type CsvIconProps = {
  color: string
}

export default function ({ color = '#384A51' }: CsvIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1607_22426)">
        <g clipPath="url(#clip1_1607_22426)">
          <path
            fill={color}
            d="M14.5938 7.5625H14.0938V4.21875C14.0938 4.09703 14.0444 3.97519 13.9565 3.88731C13.9565 3.88731 13.9565 3.88731 13.9565 3.88728L10.2065 0.137281C10.1166 0.0474375 9.99414 0 9.87502 0H3.31251C2.5371 0 1.90625 0.630844 1.90625 1.40625V7.5625H1.40625C0.630845 7.5625 0 8.19334 0 8.96875V14.5938C0 15.3692 0.630845 16 1.40625 16H14.5938C15.3692 16 16 15.3692 16 14.5938V8.96875C16 8.19334 15.3692 7.5625 14.5938 7.5625ZM10.3438 1.60041L12.4934 3.75H10.8125C10.5541 3.75 10.3438 3.53972 10.3438 3.28125V1.60041ZM2.84376 1.40625C2.84376 1.14778 3.05404 0.9375 3.31251 0.9375H9.40627V3.28125C9.40627 4.05666 10.0371 4.6875 10.8125 4.6875H13.1563V7.5625H2.84376V1.40625ZM15.0625 14.5938C15.0625 14.8522 14.8522 15.0625 14.5938 15.0625H1.40625C1.14778 15.0625 0.937502 14.8522 0.937502 14.5938V8.96875C0.937502 8.71028 1.14778 8.5 1.40625 8.5H14.5938C14.8522 8.5 15.0625 8.71028 15.0625 8.96875V14.5938Z"
          />
          <path
            fill={color}
            d="M4.25 10.375C4.50847 10.375 4.71875 10.5853 4.71875 10.8438C4.71875 11.1026 4.92863 11.3125 5.1875 11.3125C5.44638 11.3125 5.65626 11.1026 5.65626 10.8438C5.65626 10.0683 5.02541 9.4375 4.25 9.4375C3.47459 9.4375 2.84375 10.0683 2.84375 10.8438V12.7188C2.84375 13.4942 3.47459 14.125 4.25 14.125C5.02541 14.125 5.65626 13.4942 5.65626 12.7188C5.65626 12.4599 5.44638 12.25 5.1875 12.25C4.92863 12.25 4.71875 12.4599 4.71875 12.7188C4.71875 12.9772 4.50847 13.1875 4.25 13.1875C3.99153 13.1875 3.78125 12.9772 3.78125 12.7188V10.8438C3.78125 10.5853 3.99153 10.375 4.25 10.375Z"
          />
          <path
            fill={color}
            d="M8 11.3125C7.74153 11.3125 7.53125 11.1022 7.53125 10.8438C7.53125 10.5853 7.74153 10.375 8 10.375C8.12522 10.375 8.24291 10.4238 8.33144 10.5123C8.51444 10.6953 8.81125 10.6953 8.99435 10.5123C9.17741 10.3292 9.17741 10.0324 8.99435 9.84937C8.72875 9.58378 8.37566 9.4375 8 9.4375C7.2246 9.4375 6.59375 10.0683 6.59375 10.8438C6.59375 11.6192 7.2246 12.25 8 12.25C8.25847 12.25 8.46875 12.4603 8.46875 12.7188C8.46875 12.9772 8.25847 13.1875 8 13.1875C7.87478 13.1875 7.7571 13.1387 7.66856 13.0502C7.48556 12.8672 7.18875 12.8672 7.00566 13.0502C6.82259 13.2333 6.82259 13.5301 7.00566 13.7131C7.27125 13.9787 7.62435 14.125 8 14.125C8.77541 14.125 9.40626 13.4942 9.40626 12.7188C9.40626 11.9433 8.77541 11.3125 8 11.3125Z"
          />
          <path
            fill={color}
            d="M12.8013 9.45161C12.5504 9.38892 12.2956 9.54148 12.2329 9.79267L11.7501 11.7236L11.2673 9.79267C11.2045 9.54148 10.9499 9.38883 10.6989 9.45161C10.4478 9.51439 10.2951 9.76889 10.3579 10.02L11.2954 13.77C11.3475 13.9787 11.535 14.1251 11.7501 14.1251C11.9652 14.1251 12.1527 13.9787 12.2048 13.77L13.1423 10.02C13.2052 9.76889 13.0524 9.51439 12.8013 9.45161Z"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1607_22426">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_1607_22426">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
